export default __webpack_public_path__ + "static/media/les_copy.dc0adf1c.svg";